import React, { FC } from "react";
import UniversalTable from "../../organization/table/UniTable";
import { IStation } from "../../../models/IUser";
import { WithModified } from "./utils/modifiedFields";

interface PopupStationsTableProps {
  data: WithModified<IStation>[];
  onCellChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    stationId?: number,
  ) => void;
  // `DEV-93`: кнопка «Замена счётчика» у строки станции.
  onMeterReplace?: (station: WithModified<IStation>) => void;
  // `S.2`: переключатель опроса станции.
  onPollingToggle?: (station: WithModified<IStation>) => void;
}

export const PopupStationsTable: FC<PopupStationsTableProps> = ({
  data,
  onCellChange,
  onMeterReplace,
  onPollingToggle,
}) => {
  return (
    <UniversalTable
      data={data}
      type="stationsInModule"
      setOrg={() => {}}
      Edit={() => {}}
      goto={undefined}
      onCellChange={onCellChange}
      onMeterReplace={onMeterReplace}
      onPollingToggle={onPollingToggle}
    />
  );
};
